import React from 'react'

import cmThumbnailWorkation from '../../public/cm_section_thumbnail_workation.png'
import cmThumbnailOshikatsu from '../../public/cm_section_thumbnail_oshikatsu.png'
import cmSectionLabel from '../../public/cm_section_label.png'
import { VideoPlayer } from '../VideoPlayer'

type CmSectionMovieProps = {
  isPc?: boolean
}

const CmSectionMovie = ({ isPc }: CmSectionMovieProps) => {
  return (
    <section className="relative py-[60px] sp:py-[50px] bg-pink-m1">
      <img
        src={cmSectionLabel.src}
        alt="CMで話題"
        className="absolute
          2xl:top-[2vw] 2xl:right-[28vw] 2xl:w-[5vw]
          xl:top-[4.5vw] xl:right-[12.5vw] xl:w-[8vw]
          lg:top-[5vw] lg:right-[3vw] lg:w-[11vw]
          md:top-[3vw] md:right-[4vw] md:w-[13vw]
          top-[2vw] right-[2vw] w-[18.5vw]"
      />
      <h2 className="text-[27px] font-bold mb-[20px] text-center tracking-[0.15em] sp:text-[18px]">
        あなたは
        <br />
        どんな働き方を叶えたい？
      </h2>
      {isPc ? (
        <div className="flex gap-5 justify-center items-start max-w-[1540px] mx-auto mt-[45px] sp:flex-col sp:gap-[15px] sp:mt-5">
          <VideoPlayer
            title="推し活CM"
            thumbnail={cmThumbnailOshikatsu.src}
            src="https://player.vimeo.com/video/1105753456"
            videoID="cmSection"
          />
          <VideoPlayer
            title="ワーケーションCM"
            thumbnail={cmThumbnailWorkation.src}
            src="https://player.vimeo.com/video/1105753425"
            videoID="cmSection"
          />
        </div>
      ) : (
        <VideoPlayer
          title="ワーケーションCM"
          thumbnail={cmThumbnailWorkation.src}
          src="https://player.vimeo.com/video/1105753425"
          videoID="cmSection"
        />
      )}
    </section>
  )
}

export default CmSectionMovie
